import React from 'react';
import styled from 'styled-components';

const IconContainer = styled.div`
  font-size: 20px;
  padding: 3px 0 1px 7px;

  &.explorer {
    padding: 4px 0 0 7px;
  }
`;

export default IconContainer;
